module.exports = __webpack_public_path__ + "img/liutong.ccee51b1.png";